import type { IconProps } from "./icon-types";

/**
 * 아래 방향 chevron. Dropdown trigger 등에서 열림 상태에 `rotate(180deg)`로 뒤집어 쓴다.
 * 회전/transition은 호출부(`styled(ChevronIcon)`)에서 부여.
 */
export const ChevronIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true" {...props}>
    <path
      d="M4 6l4 4 4-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
